import { render, staticRenderFns } from "./UserResetPassword.vue?vue&type=template&id=3fa4b898"
import script from "./UserResetPassword.js?vue&type=script&lang=js&external"
export * from "./UserResetPassword.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports